module.exports = __webpack_public_path__ + "img/1888.aa8088e2.png";